import { render, staticRenderFns } from "./ProcEdit.vue?vue&type=template&id=23f1bb60&scoped=true&"
import script from "./ProcEdit.vue?vue&type=script&lang=js&"
export * from "./ProcEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1bb60",
  null
  
)

export default component.exports